import { h, FunctionalComponent } from 'preact'
import Bubble from '../Bubble'
import s from './MenuItem.css'

interface iProps {
  onClick: (e: Event) => void
}

const MenuItem: FunctionalComponent<iProps> = ({ children, ...restProps }) => {
  return (
    <Bubble
      tag="button"
      className={s.MenuItem}
      {...restProps}
    >
      {children}
    </Bubble>
  )
}

export default MenuItem
